<button (click)="toggleExpanded()" motifButton color="link-alt" size="small">
  {{ label() }}<motif-icon size="20" [iconFunction]="icon()" />
</button>
